<div style="padding: 1vw" [ngStyle]="{opacity:reset?'0.3':'1'}">
  <mat-accordion [multi]="true">
    <mat-expansion-panel
      [expanded]="channelPanelOpenState()"
      (opened)="channelPanelOpenState.set(true)"
      (closed)="channelPanelOpenState.set(false)"
      hideToggle
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="main-content-accordian">
            <div class="main-content-accordian-title">
              <h6 class="heading">
                Channel: {{ this.review_kpis["channel"] }}
              </h6>
              <p class="subheading">
                Unit: {{ planogram_details.unit || this.review_kpis["unit"] }} |
                Cooler:
                {{ this.review_kpis["cooler_type"] }}
              </p>
            </div>

            <img
              [src]="
                channelPanelOpenState()
                  ? '../../assets/accordian-open.svg'
                  : '../../assets/accordian-close.svg'
              "
            />
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <mat-card appearance="outlined">
          <div
            class="channel-container"
            [ngStyle]="{
              'grid-template-columns': 'repeat(' + numberOfColumns + ', 1fr)'
            }"
          >
            <div class="channel-items"></div>
            <div
              class="channel-heading channel-items"
              *ngFor="let item of numberOfShelvesAndFacing() | keyvalue"
            >
              {{ item.key }}
            </div>
            <div class="channel-items">Shelves</div>
            <div
              class="channel-items"
              *ngFor="let item of numberOfShelvesAndFacing() | keyvalue"
            >
              {{ getChannelOutput(item.value, "shelves") }}
            </div>
            <div class="channel-items">Facings</div>
            <div
              class="channel-items"
              *ngFor="let item of numberOfShelvesAndFacing() | keyvalue"
            >
              {{ getChannelOutput(item.value, "product_facings") }}
            </div>

            <div class="channel-items">Config</div>
            <div
              class="channel-items"
              *ngFor="let item of numberOfShelvesAndFacing() | keyvalue"
            >
              <pre
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin: 0px;
                  font-family: Montserrat;
                  text-align: center;
                "
                >{{ getChannelOutput(item.value, "shelf_configs") }}</pre
              >
            </div>
          </div>
        </mat-card>
        <mat-card appearance="outlined" style="margin-top: 15px">
          <div>
            <div
              class="channel-heading channel-items"
              style="border-bottom: none"
            >
              Pack Order
              <mat-icon
                ngxTippy
                [tippyProps]="{
                  allowHTML: true,
                  placement: 'top',
                  content: packOrderDescription()
                }"
                >info</mat-icon
              >
            </div>
            <div class="pack-content">
              <div
                class="channel-items"
                style="border-bottom: none"
                *ngFor="let item of packOrder()"
              >
                <div *ngIf="item.length > 5" [matTooltip]="item">
                  {{ item.slice(0, 4) + ".." }}
                </div>
                <div *ngIf="item.length < 5">{{ item }}</div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </mat-expansion-panel>
    <!-- Estimated OTV -->
    <mat-expansion-panel
      [expanded]="estimatedPanelOpenState()"
      (opened)="estimatedPanelOpenState.set(true)"
      (closed)="estimatedPanelOpenState.set(false)"
      hideToggle
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="main-content-accordian">
            <div class="main-content-accordian-title">
              <h6 class="heading">Estimated OTV</h6>
              <p></p>
            </div>

            <img
              [src]="
                estimatedPanelOpenState()
                  ? '../../assets/accordian-open.svg'
                  : '../../assets/accordian-close.svg'
              "
            />
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <mat-card appearance="outlined">
          <div class="estimated-otv-container">
            <div class="center-review column-review">
              <div class="estimated-otv-item">
                &#8377; {{ this.review_kpis["revenue"] }}
              </div>
              One Turn Value
            </div>
            <div class="center-review column-review">
              <div class="estimated-otv-item">
                &#8377; {{ this.review_kpis["profit"] }}
              </div>
              Profit
            </div>
            <div class="center-review column-review">
              <div class="estimated-otv-item">
                {{ this.review_kpis["volume"] }}UC
              </div>
              Volume
            </div>
          </div>
        </mat-card>
      </div>
    </mat-expansion-panel>
    <!-- category mix panel -->
    <mat-expansion-panel
      class="category-brand-pack"
      [expanded]="categoryMixPanelOpenState()"
      (opened)="categoryMixPanelOpenState.set(true)"
      (closed)="categoryMixPanelOpenState.set(false)"
      hideToggle
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="main-content-accordian">
            <div class="main-content-accordian-title">
              <h6 class="heading">Category Mix</h6>
              <p></p>
            </div>

            <img
              [src]="
                categoryMixPanelOpenState()
                  ? '../../assets/accordian-open.svg'
                  : '../../assets/accordian-close.svg'
              "
            />
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <mat-list>
          <mat-list-item
            *ngFor="
              let representation of populateRepresentation(
                'category_distribution'
              )
            "
          >
            <div class="representation-container">
              <div
                class="center-review"
                style="font-size: 0.9vw"
                [matTooltip]="representation"
              >
                {{ representation }}
              </div>
              <div class="center" style="margin: 0px 2px">
                <!-- <mat-progress-bar mode="determinate" color="warn"
                  [value]="valueOfRepresntation(representation,'category_distribution')"></mat-progress-bar> -->

                <div class="progress rounded-corner">
                  <div
                    class="progress-done"
                    [ngStyle]="{
                      'width.%': valueOfRepresntation(
                        representation,
                        'category_distribution'
                      )
                    }"
                  ></div>
                </div>
              </div>
              <div
                class="center"
                style="font-size: 0.85vw; color: #41b883; font-weight: 500"
              >
                +
                {{
                  valueOfRepresntation(representation, "category_distribution")
                }}
                %
              </div>
            </div>
            <!-- 
                  <mat-progress-bar
                  *ngIf="!isReset"
                    color="warn"
                    mode="determinate"
                    [value]="valueOfRepresntation(representation)"
                  />
                  <mat-progress-bar
                  class="disabled-progress-bar"
                  *ngIf="isReset"
                  color="warn"
                  mode="determinate"
                  [value]=""
                /> -->
          </mat-list-item>
        </mat-list>
      </div>
    </mat-expansion-panel>

    <!-- brand mix -->
    <mat-expansion-panel
      class="category-brand-pack"
      [expanded]="brandMixPanelOpenState()"
      (opened)="brandMixPanelOpenState.set(true)"
      (closed)="brandMixPanelOpenState.set(false)"
      hideToggle
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="main-content-accordian">
            <div class="main-content-accordian-title">
              <h6 class="heading">Brand Mix</h6>
              <p></p>

              <!-- <p class="subheading">Unit: India | Cooler: 2 Door</p> -->
            </div>

            <img
              [src]="
                brandMixPanelOpenState()
                  ? '../../assets/accordian-open.svg'
                  : '../../assets/accordian-close.svg'
              "
            />
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <mat-list>
          <mat-list-item
            *ngFor="
              let representation of populateRepresentation('brand_distribution')
            "
          >
            <div class="representation-container">
              <div
                class="center-review"
                [matTooltip]="representation"
                style="font-size: 0.9vw"
              >
                {{ representation }}
              </div>
              <div class="center" style="margin: 0px 2px">
                <div class="progress rounded-corner">
                  <div
                    class="progress-done"
                    [ngStyle]="{
                      'width.%': valueOfRepresntation(
                        representation,
                        'brand_distribution'
                      )
                    }"
                  ></div>
                </div>
                <!-- <mat-progress-bar mode="determinate" color="warn"
                  [value]="valueOfRepresntation(representation,'brand_distribution')"></mat-progress-bar> -->
              </div>
              <div
                class="center"
                style="font-size: 0.85vw; color: #41b883; font-weight: 500"
              >
                +
                {{ valueOfRepresntation(representation, "brand_distribution") }}
                %
              </div>
            </div>
            <!-- 
                  <mat-progress-bar
                  *ngIf="!isReset"
                    color="warn"
                    mode="determinate"
                    [value]="valueOfRepresntation(representation)"
                  />
                  <mat-progress-bar
                  class="disabled-progress-bar"
                  *ngIf="isReset"
                  color="warn"
                  mode="determinate"
                  [value]=""
                /> -->
          </mat-list-item>
        </mat-list>
      </div>
    </mat-expansion-panel>

    <!-- pack mix -->
    <mat-expansion-panel
      class="category-brand-pack"
      [expanded]="packMixPanelOpenState()"
      (opened)="packMixPanelOpenState.set(true)"
      (closed)="packMixPanelOpenState.set(false)"
      hideToggle
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="main-content-accordian">
            <div class="main-content-accordian-title">
              <h6 class="heading">Pack Mix</h6>
              <p></p>

              <!-- <p class="subheading">Unit: India | Cooler: 2 Door</p> -->
            </div>

            <img
              [src]="
                packMixPanelOpenState()
                  ? '../../assets/accordian-open.svg'
                  : '../../assets/accordian-close.svg'
              "
            />
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <mat-list>
          <mat-list-item
            *ngFor="
              let representation of populateRepresentation(
                'pack_segment_distribution'
              )
            "
          >
            <div class="representation-container">
              <div
                class="center-review"
                style="font-size: 0.9vw"
                [matTooltip]="representation"
              >
                {{ representation }}
              </div>
              <div class="center" style="margin: 0px 2px">
                <div class="progress rounded-corner">
                  <div
                    class="progress-done"
                    [ngStyle]="{
                      'width.%': valueOfRepresntation(
                        representation,
                        'pack_segment_distribution'
                      )
                    }"
                  ></div>
                </div>
                <!-- <mat-progress-bar mode="determinate" color="warn"
                  [value]="valueOfRepresntation(representation,'pack_segment_distribution')"></mat-progress-bar> -->
              </div>
              <div
                class="center"
                style="font-size: 0.85vw; color: #41b883; font-weight: 500"
              >
                +
                {{
                  valueOfRepresntation(
                    representation,
                    "pack_segment_distribution"
                  )
                }}
                %
              </div>
            </div>
            <!-- 
                  <mat-progress-bar
                  *ngIf="!isReset"
                    color="warn"
                    mode="determinate"
                    [value]="valueOfRepresntation(representation)"
                  />
                  <mat-progress-bar
                  class="disabled-progress-bar"
                  *ngIf="isReset"
                  color="warn"
                  mode="determinate"
                  [value]=""
                /> -->
          </mat-list-item>
        </mat-list>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
